<script lang="ts">var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b, _c, _d, _e, _f, _g;
import LinkAccountCard from "../LinkAccountCard/LinkAccountCard.svelte";
import { YinzCamCardsServiceElement } from 'yinzcam-cards';
import CardBase from '../../../common/CardBase.svelte';
import { findSourceStore } from '../../../utilities';
import { Readable } from 'svelte/store';
import { CardsDataSourceRegistration } from '../../../common/CardsDataSourceRegistration';
import { JanusSignonManagerToken } from "../../../../../js/sso";
import { getToken } from 'inversify-token';
import ROOT from '../../../../../inversify.config';
import { resolveUrl } from '../../../../../js/url';
import { ycSSOThirdPartyAuth } from '../../../../../js/ycapp';
import { f7 } from 'framework7-svelte';
import { onMount } from "svelte";
export let element;
export let sources;
export let sourceStore;
const signonManager = getToken(ROOT, JanusSignonManagerToken);
$: clientConfig = (_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.clientConfig;
$: linkStore = findSourceStore($sources, 'YinzCamSignonServerLinks');
$: links = linkStore && ($linkStore === null || $linkStore === void 0 ? void 0 : $linkStore.Link);
$: specificAppId = ((_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.specificAppId) || null;
$: titleOverride = ((_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.titleOverride) || null;
$: imageOverrideUrl = ((_d = element === null || element === void 0 ? void 0 : element.data) === null || _d === void 0 ? void 0 : _d.imageOverrideUrl) || null;
$: linkCompleteAvatarImageUrl = ((_e = element === null || element === void 0 ? void 0 : element.data) === null || _e === void 0 ? void 0 : _e.linkCompleteAvatarImageUrl) || null;
$: linkCompleteImageOverrideUrl = ((_f = element === null || element === void 0 ? void 0 : element.data) === null || _f === void 0 ? void 0 : _f.linkCompleteImageOverrideUrl) || null;
$: connected = (((links === null || links === void 0 ? void 0 : links.length) > 0) ? links.find(l => (l === null || l === void 0 ? void 0 : l.Type) === 'NFLID' && (!specificAppId || specificAppId === (l === null || l === void 0 ? void 0 : l.AppId))) : null) || false;
$: endWorkflow = (_g = element === null || element === void 0 ? void 0 : element.data) === null || _g === void 0 ? void 0 : _g.endWorkflow;
let profileStore;
$: profileStore = findSourceStore($sources, 'YinzCamSignonServerProfile');
$: profileSource = $sources.find((s) => { var _a; return ((_a = s.spec) === null || _a === void 0 ? void 0 : _a.class) === 'YinzCamSignonServerProfile'; });
$: entries = profileStore ? $profileStore === null || $profileStore === void 0 ? void 0 : $profileStore.Entry : [];
let profileRefreshed = false;
$: if (profileSource && !profileRefreshed) {
    setTimeout(() => {
        profileSource.refresh();
    }, 0);
    profileRefreshed = true;
}
let data = {};
$: {
    entries === null || entries === void 0 ? void 0 : entries.map(item => {
        data[item.Key] = item.Value;
    });
}
$: nfl_id_email = (data === null || data === void 0 ? void 0 : data.email) || ({})['email'] || "";
$: usePing = (clientConfig === null || clientConfig === void 0 ? void 0 : clientConfig.usePing) || false;
$: baseUri = (clientConfig === null || clientConfig === void 0 ? void 0 : clientConfig.baseUri) || "https://id.nfl.com";
$: apiKey = encodeURIComponent((clientConfig === null || clientConfig === void 0 ? void 0 : clientConfig.apiKey) || "");
$: clientId = (clientConfig === null || clientConfig === void 0 ? void 0 : clientConfig.clientId) || "";
$: clientIdParam = encodeURIComponent(clientId);
$: redirectUri = (clientConfig === null || clientConfig === void 0 ? void 0 : clientConfig.redirectUri) || new URL("/modals/en/NFLIDOpenIDRedirect", document.baseURI).href;
$: redirectUriParam = encodeURIComponent(redirectUri);
$: scope = (clientConfig === null || clientConfig === void 0 ? void 0 : clientConfig.scope) || "openid profile email";
$: scopeParam = encodeURIComponent(scope);
const onConnect = (autoLink) => __awaiter(void 0, void 0, void 0, function* () {
    if (!connected) {
        const codeVerifier = signonManager.generatePKCECodeVerifier();
        const challenge = yield signonManager.generatePKCEChallenge(codeVerifier);
        window.localStorage.setItem('NFLIDOpenIDCodeVerifier', codeVerifier);
        const state = 'yinzcam';
        const tpaConfig = Object.assign({ url: `${baseUri}/oidc/op/v1.0/${apiKey}/authorize?client_id=${clientIdParam}&scope=${scopeParam}&response_type=code&redirect_uri=${redirectUriParam}&code_challenge=${challenge}&code_challenge_method=S256&state=${state}`, redirectUri }, ((!_.isNil(clientConfig.ephemeral)) ? { ephemeral: clientConfig.ephemeral } : undefined));
        ycSSOThirdPartyAuth("OAUTH", tpaConfig, (method, clientResult) => __awaiter(void 0, void 0, void 0, function* () {
            var _h, _j;
            console.log("ycSSOThirdPartyAuth callback inside OAUTH (NFLIDOpenID)", method, clientResult);
            const codeVerifier = window.localStorage.getItem('NFLIDOpenIDCodeVerifier');
            window.localStorage.removeItem('NFLIDOpenIDCodeVerifier');
            if (clientResult === null || clientResult === void 0 ? void 0 : clientResult.error) {
                console.error('Client Error: ' + clientResult.error);
                signonManager.fireWorkflowEndEvent();
                return;
            }
            if (!(clientResult === null || clientResult === void 0 ? void 0 : clientResult.redirectUri)) {
                console.warn(`ycSSOThirdPartyAuth callback for OAUTH (NFLIDOpenID): missing redirectUri`);
                signonManager.fireWorkflowEndEvent();
                return;
            }
            const redirectParams = new URL(clientResult.redirectUri).searchParams;
            const checkState = redirectParams.get('state');
            if (checkState !== state) {
                alert("Missing or invalid NFLID OpenID response.");
                signonManager.fireWorkflowEndEvent();
                return;
            }
            const code = redirectParams.get('code');
            if (!code || !codeVerifier) {
                alert("Missing or invalid NFLID OpenID response.");
                signonManager.fireWorkflowEndEvent();
                return;
            }
            let result;
            f7.preloader.show('white');
            try {
                result = yield signonManager.linkWithNFLIDOpenIDAccount(clientId, scope, redirectUri, code, codeVerifier, usePing, true);
            }
            finally {
                f7.preloader.hide();
            }
            if (result.success) {
                if (endWorkflow) {
                    signonManager.fireWorkflowEndEvent();
                }
                else {
                    let href = `Connected?linkedImage=${encodeURIComponent(linkCompleteImageOverrideUrl || '/static/icons/icon-nfl.png')}`;
                    if (linkCompleteAvatarImageUrl) {
                        href += `&avatarImage=${encodeURIComponent(linkCompleteAvatarImageUrl)}`;
                    }
                    resolveUrl(href).func();
                }
            }
            else {
                alert(((_j = (_h = result.data) === null || _h === void 0 ? void 0 : _h.UserMessage) === null || _j === void 0 ? void 0 : _j.Content) || 'An error occurred.');
            }
        }));
    }
    else if (!autoLink) {
        let url = `DisconnectAccounts?accountType=nflid`;
        if (specificAppId) {
            url += `&specificAppId=${encodeURIComponent(specificAppId)}`;
        }
        const resolved = resolveUrl(url);
        resolved.func();
    }
});
onMount(() => {
    var _a;
    if ((_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.autoLink) {
        onConnect(true);
    }
});
</script>

<CardBase {element}>
    {#if !(element && element.data && element.data.autoLink)}
    <LinkAccountCard title={titleOverride || 'NFL Account'} image={imageOverrideUrl || '/static/icons/icon-nfl.png'} onConnect={() => onConnect(false)} {connected} {sources} email = {nfl_id_email} imgStyleOverride="border: 1px solid #FFFFFF;"/>
    {/if}
</CardBase>
